<template>
  <!--  -->
  <div class="flex items-center justify-center gap-3">
    <!--  -->
    <button
      v-if="paginate.currentpage > 1"
      @click="handlePagination('prev')"
      :disabled="paginate.currentpage === 1"
      class="min-w-[32px] h-8 flex justify-center items-center text-base rounded-[6px] border border-primary bg-white text-primary hover:bg-primary hover:text-white transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary/30"
    >
      <!--  -->
      <Icon icon="heroicons-outline:arrow-left" class="text-lg" />
      <!--  -->
    </button>
    <!--  -->

    <!--  -->
    <div
      class="flex items-center space-x-2"
    >
      <!--  -->
      <button
        v-if="showFirstPageButton"
        @click="goToPage(1)"
        :class="[
          'min-w-[32px] h-8 flex justify-center items-center rounded-[6px] border border-slate-200 transition-all duration-200 cursor-pointer font-medium',
          paginate.currentpage === 1
            ? 'bg-primary text-white shadow-sm'
            : 'bg-white hover:bg-slate-200 text-slate-700',
        ]"
      >
        1
      </button>
      <!--  -->

      <!--  -->
      <div
        v-if="showLeftEllipsis"
        class="min-w-[32px] h-8 flex justify-center items-center bg-white text-slate-500 font-medium rounded-[6px] border border-slate-200"
      >
        ...
      </div>
      <!--  -->

      <!--  -->
      <button
        v-for="page in visiblePageNumbers"
        :key="page"
        @click="goToPage(page)"
        :class="[
          'min-w-[32px] h-8 flex justify-center items-center rounded-[6px] border border-slate-200 transition-all duration-200 cursor-pointer font-medium',
          paginate.currentpage === page
            ? 'bg-primary text-white shadow-sm'
            : 'bg-white hover:bg-slate-200 text-slate-700',
        ]"
      >
        {{ page }}
      </button>
      <!--  -->

      <!--  -->
      <div
        v-if="showRightEllipsis"
        class="min-w-[32px] h-8 flex justify-center items-center bg-white text-slate-500 font-medium rounded-[6px] border border-slate-200"
      >
        ...
      </div>
      <!--  -->

      <!--  -->
      <button
        v-if="showLastPageButton"
        @click="goToPage(paginate.lastpage)"
        :class="[
          'min-w-[32px] h-8 flex justify-center items-center rounded-[6px] border border-slate-200 transition-all duration-200 cursor-pointer font-medium',
          paginate.currentpage === paginate.lastpage
            ? 'bg-primary text-white shadow-sm'
            : 'bg-white hover:bg-slate-200 text-slate-700',
        ]"
      >
        {{ paginate.lastpage }}
      </button>
      <!--  -->
    </div>
    <!--  -->

    <!--  -->
    <button
      v-if="paginate.currentpage < paginate.lastpage"
      @click="handlePagination('next')"
      :disabled="paginate.currentpage === paginate.lastpage"
      class="min-w-[32px] h-8 flex justify-center items-center text-base rounded-[6px] border border-primary bg-white text-primary hover:bg-primary hover:text-white transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary/30"
    >
      <!--  -->
      <Icon icon="heroicons-outline:arrow-right" class="text-lg" />
      <!--  -->
    </button>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
export default {
  name: "DivPagination",
  props: {
    paginate: {
      type: Object,
      required: true,
      validator: (obj) => {
        return "currentpage" in obj && "lastpage" in obj;
      },
    },
    maxVisiblePages: {
      type: Number,
      default: 4,
    },
  },
  computed: {
    visiblePageNumbers() {
      const { currentpage, lastpage } = this.paginate;
      const maxVisible = this.maxVisiblePages;

      if (lastpage <= maxVisible) {
        return Array.from({ length: lastpage }, (_, i) => i + 1);
      }

      let startPage = Math.max(currentpage - Math.floor(maxVisible / 2), 1);
      let endPage = startPage + maxVisible - 1;

      if (endPage > lastpage) {
        endPage = lastpage;
        startPage = Math.max(endPage - maxVisible + 1, 1);
      }

      return Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
      );
    },
    showFirstPageButton() {
      return this.visiblePageNumbers[0] > 1;
    },
    showLastPageButton() {
      return (
        this.visiblePageNumbers[this.visiblePageNumbers.length - 1] <
        this.paginate.lastpage
      );
    },
    showLeftEllipsis() {
      return this.visiblePageNumbers[0] > 2;
    },
    showRightEllipsis() {
      return (
        this.visiblePageNumbers[this.visiblePageNumbers.length - 1] <
        this.paginate.lastpage - 1
      );
    },
  },
  methods: {
    handlePagination(direction) {
      this.$emit("paginatation", direction);
    },
    goToPage(page) {
      const { currentpage } = this.paginate;
      if (page === currentpage) return;

      const direction =
        page > currentpage
          ? Array(page - currentpage).fill("next")
          : Array(currentpage - page).fill("prev");

      this.$emit("paginatation", { type: "goto", page });
    },
  },
};
</script>
